const isEmpty = (arr: any[]): boolean => Array.isArray(arr) && arr.length === 0;

export default isEmpty;
